import { HEADER_OFFSET } from "config/config";
import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isMobileDevice } from "utils";

interface ScrollToContentProps {
  children: React.ReactNode;
}

const ScrollToContent: FC<ScrollToContentProps> = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const content = document.getElementById("app-content");

    if (!content || !isMobileDevice() || pathname.includes("consent")) {
      return;
    }

    const contentTop = content.getBoundingClientRect().top;

    window.scrollTo({ top: contentTop - HEADER_OFFSET, behavior: "smooth" });
  }, [pathname]);

  return <>{children}</>;
};

export default ScrollToContent;
